import { h } from 'preact';

const Logo = () => (
	<svg
		width={252}
		height={164}
		viewBox="0 0 252 164"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.567139 0.343285V163.713H110.902V0.343285H0.567139ZM43.7606 124.347L7.2375 84.4339L19.9221 72.0773L42.7765 95.1503L89.6879 39.6002L104.122 50.5352L43.7606 124.347Z"
			fill="currentColor"
		/>
		<path
			d="M251.304 0.343285H119.427V49.0043H251.304V0.343285Z"
			fill="currentColor"
		/>
		<path
			d="M251.304 57.753H119.427V106.414H251.304V57.753Z"
			fill="currentColor"
		/>
		<path
			d="M251.304 115.052H119.427V163.713H251.304V115.052Z"
			fill="currentColor"
		/>
	</svg>
);

export default Logo;
